<template>
  <div style="height: 100%">
    <section>
      <section v-if="!loading && isMounted">
        <v-app-bar app dark prominent height="180">
          <template slot="img">
            <v-img
              :src="productImage(product.image)"
              max-height="180"
              gradient="to bottom,rgba(0, 0, 0, 0.8) 0%,transparent 80px"
            />
          </template>
          <v-btn dark icon @click="back()">
            <v-icon x-large>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            dark
            icon
            @click="
              $router.push({
                name: 'cart',
                query: { unix: Date.now().toString() }
              })
            "
          >
            <v-icon>
              mdi-cart
            </v-icon>
          </v-btn>
        </v-app-bar>
        <div
          style="overflow: auto; height: 60%;
       position: relative; "
        >
          <template v-for="comboProduct in comboProducts">
            <div :key="'product' + comboProduct.id">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="product-title" style="display: flex">{{
                      comboProduct.product.name
                    }}</v-list-item-title>
                  <v-list-item-subtitle class="overflow-subtitle">{{
                      comboProduct.product.description
                    }}</v-list-item-subtitle>
                  <v-list-item-subtitle v-if="showChangeProduct(comboProduct)" class="overflow-subtitle">
                    <v-flex xs12 class="d-flex justify-end">
                      <v-btn
                          x-small
                          outlined
                          tile
                          color="accent"
                          @click="showDialogChangeProduct(comboProduct)"
                      >
                        <v-icon x-small left>edit</v-icon>
                        Alterar produto
                      </v-btn>
                    </v-flex>
                    </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <template
                  v-if="
              comboProduct && comboProduct.product && comboProduct.product.product_accompaniments &&
                 comboProduct.product.product_accompaniments.length !== 0
            "
              >
                <v-sheet class="grey lighten-3">
                  <v-divider></v-divider>
                  <v-subheader
                      class="body-1 font-weight-bolder"
                      style="height: 40px !important"
                  >Acompanhamentos</v-subheader
                  >
                  <v-divider></v-divider>
                </v-sheet>

                <template
                    v-for="(accompaniment, i) in  comboProduct.product.product_accompaniments"
                >
                  <v-list subheader :key="'accompaniment' + i">
                    <v-subheader style="height: 40px !important">
                      {{ accompaniment.accompaniment_category.name }}
                      {{ accompanimentLength(accompaniment) }}/{{
                        accompaniment.max
                      }}
                      {{
                        accompaniment.min > 0
                            ? " — no mínimo " + accompaniment.min
                            : ""
                      }}
                    </v-subheader>
                    <template
                        v-for="(option, j) in accompaniment.accompaniment_category
                    .accompaniments"
                    >
                      <v-list-item
                          :key="'accompaniment' + j"
                          @click.stop="markOptionCategory('accompaniment', option)"
                          :disabled="
                      !option.active &&
                        accompanimentLength(accompaniment) >=
                          accompaniment.max &&
                        accompaniment.max !== 0
                    "
                      >
                        <v-list-item-action>
                          <v-checkbox
                              v-model="option.active"
                              :disabled="
                          !option.active &&
                            accompanimentLength(accompaniment) >=
                              accompaniment.max &&
                            accompaniment.max != 0
                        "
                              @click.stop="
                          markOptionCategory('accompaniment', option)
                        "
                          />
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>{{
                              option.option.name
                            }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </template>
              </template>
              <template
                  v-if="
               comboProduct && comboProduct.product && comboProduct.product.product_additionals &&
                 comboProduct.product.product_additionals.length !== 0
            "
              >
                <v-sheet class="grey lighten-3">
                  <v-divider></v-divider>
                  <v-subheader
                      class="body-1 font-weight-bolder"
                      style="height: 40px !important"
                  >Adicionais</v-subheader
                  >
                  <v-divider></v-divider>
                </v-sheet>
                <template v-for="(additional, i) in  comboProduct.product.product_additionals">
                  <v-list :key="'additional' + i">
                    <v-subheader style="height: 20px !important">
                      {{ additional.additional_category.name }}
                      {{ additionalLength(additional) }}/{{ additional.max }}
                      {{
                        additional.min > 0 ? " — no mínimo " + additional.min : ""
                      }}
                    </v-subheader>

                    <template
                        v-for="(option, j) in additional.additional_category
                    .additionals"
                    >
                      <v-list-item
                          :key="'additional' + j"
                          @click.stop="markOptionCategory('additional', option)"
                          :disabled="
                      !option.active &&
                        additionalLength(additional) >= additional.max &&
                        additional.max !== 0
                    "
                      >
                        <v-list-item-action>
                          <v-checkbox
                              v-model="option.active"
                              :disabled="
                          !option.active &&
                            additionalLength(additional) >= additional.max &&
                            additional.max !== 0
                        "
                              @click.stop="markOptionCategory('additional', option)"
                          ></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>{{
                              option.option.name
                            }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action-text class="text-right body-1">{{
                            $toBrl(option.price)
                          }}</v-list-item-action-text>
                      </v-list-item>
                    </template>
                  </v-list>
                </template>
              </template>
              <template
                  v-if="
               comboProduct && comboProduct.product && comboProduct.product.product_optionals &&
                 comboProduct.product.product_optionals.length > 0
            "
              >
                <v-sheet class="grey lighten-3">
                  <v-divider></v-divider>
                  <v-subheader
                      class="body-1 font-weight-bolder"
                      style="height: 40px !important"
                  >Opcionais</v-subheader
                  >
                  <v-divider></v-divider>
                </v-sheet>
                <template v-for="(optional, i) in comboProduct.product.product_optionals">
                  <v-flex :key="'optionals' + i">
                    <v-list subheader :key="'optional' + i">
                      <v-subheader style="height: 40px !important">
                        {{ optional.optional_category.name }}
                        {{ optionalLength(optional) }}/{{ optional.max }}
                        {{ optional.min > 0 ? " — no mínimo " + optional.min : "" }}
                      </v-subheader>
                      <template
                          v-for="(option, j) in optional.optional_category.optionals"
                      >
                        <v-list-item
                            :key="'optional-' + j"
                            @click.stop="markOptionCategory('optional', option)"
                            :disabled="
                        !option.active &&
                          optionalLength(optional) >= optional.max &&
                          optional.max !== 0
                      "
                        >
                          <v-list-item-action>
                            <v-checkbox
                                v-model="option.active"
                                :disabled="
                            !option.active &&
                              optionalLength(optional) >= optional.max &&
                              optional.max !== 0
                          "
                                @click.stop="markOptionCategory('optional', option)"
                            ></v-checkbox>
                          </v-list-item-action>
                          <v-list-item-content style="padding: 7px !important">
                            <v-list-item-title>{{
                                option.option.name
                              }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-flex>
                </template>
              </template>
              <v-divider></v-divider>
              <v-textarea
                  v-model="comboProduct.product.memo"
                  v-if="showObservation()"
                  class="pt-10 mx-2"
                  label="Observação"
                  :placeholder="'Observação do item '+comboProduct.product.name "
                  rows="1"
                  prepend-icon="mdi-comment"
              ></v-textarea>
              <v-divider></v-divider>
            </div>

          </template>
        </div>
      </section>
      <div v-else>
        <v-skeleton-loader type="image" tile></v-skeleton-loader>
        <v-skeleton-loader type="article"></v-skeleton-loader>
      </div>
    </section>
    <v-divider></v-divider>
    <v-footer app padless width="100%">
      <v-btn
        color="secondary"
        x-large
        :disabled="loading || !isMounted"
        block
        tile
        depressed
        @click="addToCart"
      >
        <span>{{ $toBrl(product.price * amount) }}</span>
        <span class="add">Adicionar</span>
      </v-btn>
    </v-footer>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Produtos</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-radio-group v-model="radioGroup">
              <v-radio
                  v-for="n in productsToSelect.products"
                  :key="n.id"
                  :label=n.product.name
                  :value="n"
              ></v-radio>
            </v-radio-group>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="dialog = false"
          >
            Fechar
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="changeProduct()"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ProductService from "../services/productService";

export default {
  data: () => ({
    editing: null,
    product: {},
    productSelected: {},
    loading: false,
    isMounted: false,
    amount: 1,
    memo: "",
    comboProducts: [],
    accompaniments: [],
    additionals: [],
    optionals: [],
    contexts: [
      { label: "Acompanhamentos", value: "accompaniment" },
      { label: "Adicionais", value: "additional" },
      { label: "Opcionais", value: "optional" }
    ],
    toolbarHeight: "200px",
    dialog: null,
    radioGroup: null,
    productsToSelect: {

    }
  }),
  destroyed() {},
  async mounted() {
    this.loading = true;
    try {
      if (this.$route.params.cartIndex != null) {
        this.editing = this.$route.params.cartIndex
      }
      if (this.$route.params.product)
        this.product = JSON.parse(JSON.stringify(this.$route.params.product));
      if (!this.product.id) {
        const pdv = this.$route.params.pdv;
        if (!this.$route.params.id) await this.$router.push("/");

        this.product = await new ProductService().getProductComboByID(
          this.$route.params.id
        );
        this.product.pdv = pdv;

        if (this.product.id === 0) await this.$router.push("/");
      }
      this.amount = 1;
      if (this.product.amount != null) this.amount = this.product.amount;
      this.memo = this.product.memo;

      console.log(this.product)
      this.product.products_group.forEach(productGroup =>{
        productGroup.products.forEach(product =>{
          if (product.default){
            this.comboProducts.push(product)
            if (this.product.accompaniments != null)
              this.accompaniments = product.product.accompaniments;
            if (this.product.additionals != null)
              this.additionals = product.product.additionals;
            if (this.product.optionals != null)
              this.optionals = product.product.optionals;
          }
        })
      })

    } catch (e) {
      console.error(e);
    }
    this.loading = false;
    this.isMounted = true;
  },
  methods: {
    back() {
      this.$destroy();
      this.$router.go(-1);
    },
    productImage(image) {
      if (image)
        return image.replace(new RegExp("&size=200", "g"), "&size=600");
    },
    additionalLength(obj) {
      const arr = this.additionals.filter(
        a => a.additional_category_id === obj.additional_category_id
      );
      return arr.length;
    },
    accompanimentLength(obj) {
      const arr = this.accompaniments.filter(
        a => a.accompaniment_category_id === obj.accompaniment_category_id
      );
      return arr.length;
    },
    optionalLength(obj) {
      const arr = this.optionals.filter(
        a => a.optional_category_id === obj.optional_category_id
      );
      return arr.length;
    },
    showObservation() {
      return localStorage.getItem("showObservation").toString() === "true";
    },
    increment() {
      this.amount = parseInt(this.amount, 10) + 1;
    },
    decrement() {
      if (parseInt(this.amount, 10) === 1) return;
      this.amount = parseInt(this.amount, 10) - 1;
    },
    amountChange() {
      if (!this.amount || parseInt(this.amount, 10) === 0) this.amount = 1;
    },
    markOptionCategory(category, option) {
      option.active = !option.active;
      const i = this[`${category}s`].indexOf(
        this[`${category}s`].filter(o => o.id === option.id)[0]
      );
      if (i === -1) {
        if (category === "additional") this.product.price += option.price;
        this[`${category}s`].push(option);
      } else {
        if (category === "additional") this.product.price -= option.price;
        this[`${category}s`].splice(i, 1);
      }
    },
    addToCart() {
      this.product.amount = this.amount;
      this.product.products = this.comboProducts;

      this.validate();

      let cart = {
        products: []
      };
      if (localStorage.getItem("cart") != null) {
        cart = JSON.parse(localStorage.getItem("cart"));
      }
      if (this.editing != null) cart.products[this.editing] = this.product;
      else cart.products.push(this.product);
      localStorage.setItem("cart", JSON.stringify(cart));
      this.$router.push({
        name: "cart",
        query: { unix: Date.now().toString() }
      });
      this.$destroy()
    },
    validate() {
      this.validateAccompaniments();
      this.validateAdditionals();
      this.validateOptionals();
    },
    validateAccompaniments() {
      console.log(this.comboProducts)
      this.comboProducts.forEach(comboProduct =>{
        comboProduct.product.product_accompaniments.forEach(product_accompaniment => {
          if (product_accompaniment.min > 0) {
            let accompanimentsAmount = 0;
            product_accompaniment.accompaniment_category.accompaniments.forEach(
                acc => {
                  if (acc.active){
                    accompanimentsAmount ++;
                  }
                }
            );
            if (accompanimentsAmount < product_accompaniment.min) {
              const error = `Selecione no mínimo ${product_accompaniment.min} ${
                  product_accompaniment.min > 1 ? "opções" : "opção"
              } de acompanhamento da categoria ${
                  product_accompaniment.accompaniment_category.name
              } do produto ${comboProduct.product.short_name}`;
              this.$info("", error, "error");
              throw error;
            }
          }
        });
      });

    },
    validateAdditionals() {
      this.comboProducts.forEach(comboProduct =>{
        comboProduct.product.product_additionals.forEach(product_additional => {
          if (product_additional.min > 0) {
            let additionalsAmount = 0;
            product_additional.additional_category.additionals.forEach(acc => {
              if (acc.active)additionalsAmount++;
            });
            if (additionalsAmount < product_additional.min) {
              const error = `Selecione no mínimo ${product_additional.min} ${
                  product_additional.min > 1 ? "opções" : "opção"
              } de adicional da categoria ${
                  product_additional.additional_category.name
              } do produto ${comboProduct.product.short_name}`;
              this.$info("", error, "error");
              throw error;
            }
          }
        });

      })
    },
    validateOptionals() {
      this.comboProducts.forEach(comboProduct => {
        comboProduct.product.product_optionals.forEach(product_optional => {
          if (product_optional.min > 0) {
            let optionalsAmount = 0;
            product_optional.optional_category.optionals.forEach(acc => {
              if (acc.active)optionalsAmount++;
            });
            if (optionalsAmount < product_optional.min) {
              const error = `Selecione no mínimo ${product_optional.min} ${
                  product_optional.min > 1 ? "opções" : "opção"
              } de acompanhamento da categoria ${
                  product_optional.optional_category.name
              } do produto ${comboProduct.product.short_name}`;
              this.$info("", error, "error");
              throw error;
            }
          }
        });
      });
    },
    showChangeProduct(comboProduct) {
      let show = false;
      for (let i = 0; i < this.product.products_group.length; i++){
        const pro = this.product.products_group[i];
        if (pro.id === comboProduct.products_group_id){
          if (pro.products.length > 1){
            show=true;
          }
          break;
        }
      }
      return show;
    },
    showDialogChangeProduct(comboProduct) {
      for (let i = 0; i < this.product.products_group.length; i++){
        const pro = this.product.products_group[i];
        if (pro.id === comboProduct.products_group_id){
          this.productsToSelect = pro;
          this.radioGroup = comboProduct;
          break;
        }
      }
      this.dialog = true;

    },
    changeProduct() {
      let idx = -1;
      for (let i = 0; i < this.comboProducts.length; i++){
        if (this.comboProducts[i].products_group_id === this.radioGroup.products_group_id){
          idx = i;
          break;
        }
      }
      this.comboProducts[idx] = this.radioGroup;
      this.dialog = false;
    }
  },
};
</script>

<style>
.product-title {
  font-weight: bold !important;
  font-size: large !important;
  color: #3d3d3d !important;
}

.product-list {
  height: calc(100vh - 200px);
  overflow: scroll;
}

.product-amount {
  padding: 0 15px 0 0 !important;
  margin: 0 !important;
}

.product-amount .v-input__control .v-input__slot {
  margin: 0 !important;
}

#product-amount {
  text-align: center !important;
}

.add {
  text-align: right;
  width: 100%;
}

.lightbox {
  /*background-image:*/
  /*    linear-gradient(to bottom, rgba(245, 246, 252, 0.52), rgba(117, 19, 93, 0.73)),*/
  /*    url('images/background.jpg');*/
  width: 100%;
  height: 400px;
  background-size: cover;
  color: white;
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.8) 0%,
    transparent 80px
  );
}

.overflow-subtitle {
  display: flex !important;
  text-justify: inter-word !important;
  text-align: justify !important;
}

.v-list-item__title {
  white-space: normal !important;
}
</style>
